import PropTypes from "prop-types";
import React from "react";
import { Badge, Card, Container } from "react-bootstrap";

export const TrainingDetails = ({ puppy }) => {
  return (
    <div className="training-details">
      <Container>
        <div style={{ padding: "2rem 0" }}>
          <Card>
            <Card.Header>
              <h2>Training & Development</h2>
              <p className="text-muted mb-0">
                Professional training program completed for{" "}
                {puppy.cardHeaderTitle}
              </p>
            </Card.Header>
            <Card.Body>
              <div className="mb-4">
                <h4>Training Status</h4>
                {puppy.available ? (
                  <Badge bg="success" className="me-2">
                    Available
                  </Badge>
                ) : (
                  <Badge bg="secondary" className="me-2">
                    Sold
                  </Badge>
                )}
                {puppy.price && (
                  <Badge bg="info">Investment: {puppy.price}</Badge>
                )}
              </div>

              <div className="mb-4">
                <h5>Professional Training Program</h5>
                <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                  {puppy.cardHeaderTitle} has completed our comprehensive
                  professional training program, which includes essential
                  obedience commands, house training, socialization, and
                  behavior development. Our expert trainers have prepared{" "}
                  {puppy.cardHeaderTitle} to seamlessly integrate into their new
                  family environment.
                </p>
              </div>

              <div className="mb-4">
                <h5>Core Training Elements</h5>
                <ul style={{ fontSize: "1rem", lineHeight: "1.5" }}>
                  <li>
                    Basic obedience commands (sit, stay, come, down, heel)
                  </li>
                  <li>House training and crate training</li>
                  <li>Leash walking and public behavior</li>
                  <li>Socialization with people and other animals</li>
                  <li>Impulse control and calm behavior</li>
                  <li>Handling for grooming and veterinary care</li>
                </ul>
              </div>

              {puppy.availableDate && (
                <div className="mt-4 pt-3 border-top">
                  <h5>Availability Information</h5>
                  <p>
                    <strong>Available Date:</strong> {puppy.availableDate}
                  </p>
                  {puppy.saleUpdate && (
                    <div className="mt-3">
                      <h6>Update:</h6>
                      <p style={{ fontStyle: "italic" }}>{puppy.saleUpdate}</p>
                    </div>
                  )}
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

TrainingDetails.propTypes = {
  puppy: PropTypes.object.isRequired,
};
